import { MarketoFormInterface, I18nDataEdges } from '@lucid/utils';
import {
  Drupal,
  Maybe,
  Scalars,
  Drupal_Entity,
  LeverJson
} from 'generated/drupal-graphql';

interface ExtendedDrupal extends Drupal {
  nodeReference?: Drupal_Entity;
}

export interface PageContext {
  nid: string;
  langPrefix: string;
  LanguageId: string;
  i18nKey: string;
  pageType: string;
  extraData: string;
  entityChanged?: string;
  page?: number;
  pageCount?: number;
  pageSize?: number;
  hubAlias?: string;
  excludeFromSitemap?: boolean;
  documentationType?: string;
  categories?: string[];
  persona?: string;
  hideSsr?: boolean;
  // lucid-co specific data
  careerData?: LeverJson;
}

export interface ExtraData {
  marketoForms: { [key: string]: MarketoFormInterface };
}

export interface Data {
  drupal: ExtendedDrupal;
  i18nData?: I18nDataEdges;
}

export interface TemplateProps {
  data: Data;
  pageContext: PageContext;
  location: {
    pathname: string;
    origin: string;
    search: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    state: any;
  };
}

export interface MarketoFormField {
  targetId?: Maybe<Scalars['Int']>;
  entity?: Maybe<any>;
  targetRevisionId?: Maybe<Scalars['Int']>;
}

export function isDefined<T extends object>(
  input: null | undefined | T | string
): input is T {
  return input != null;
}

export enum Template {
  Sunrise = 'sunrise'
}

export enum WeekDay {
  Sunday = 0,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday
}
